import React from 'react';
import AppRouter from "./routers/AppRouter";
import useGlobalDialogKeyboard from "./helpers/useDialogKeyboard";

function App() {
  useGlobalDialogKeyboard();
  return <AppRouter />;
}

export default App;
